
import { Base } from '../base-component';

import './form-container-fields.component.scss';

export class FormContainerFields extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/form-container-fields/form-container-fields.component.ts